var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { cx, css as emotionCss } from 'emotion';
import { getChildrenByType } from 'react-nanny';
import { RowExpandable as Component } from './Table.styled';
import { editing as editingLegacy, trExpanded, trExpandedError, trExpansion } from '../styles/legacy';
import { editing as editingCitron, trExpanded as trExpandedCitron, trExpandedError as trExpandedErrorCitron, trExpandedWarning as trExpandedWarningCitron, trExpansion as trExpansionCitron, trExpansionError, trExpansionWarning, } from '../styles/citron';
import { getAutomation, getDebug } from '@citrus/runtime';
import { useTheme } from '@citrus/user';
import { iif, isNotNullOrEmpty, isNullOrEmpty } from '@pcty/utils';
import Tr from './Tr';
import Td from './Td';
var VERSION = '6.12.2';
/** DISPLAY NAME: &lt;TableRow.Expandable&gt; */
var RowExpandable = function (_a) {
    var _b;
    var _c = _a.alt, alt = _c === void 0 ? true : _c, automationId = _a.automationId, children = _a.children, className = _a.className, columns = _a.columns, css = _a.css, _d = _a.editing, editing = _d === void 0 ? false : _d, _e = _a.error, error = _e === void 0 ? false : _e, _f = _a.expanded, expanded = _f === void 0 ? false : _f, _g = _a.disabled, disabled = _g === void 0 ? false : _g, id = _a.id, onClick = _a.onClick, render = _a.render, _h = _a.warning, warning = _h === void 0 ? false : _h, __altByIndex = _a.__altByIndex, __checked = _a.__checked, __checkHandler = _a.__checkHandler, _j = _a.__TYPE, TYPE = _j === void 0 ? 'RowExpandable' : _j, other = __rest(_a, ["alt", "automationId", "children", "className", "columns", "css", "editing", "error", "expanded", "disabled", "id", "onClick", "render", "warning", "__altByIndex", "__checked", "__checkHandler", "__TYPE"]);
    var isCitron = useTheme().citrus2022;
    var classes = cx((_b = {},
        _b[emotionCss(css)] = isNotNullOrEmpty(css),
        _b), className || '');
    var trClasses = undefined;
    if (expanded && !disabled && !isCitron) {
        trClasses = error ? trExpandedError : trExpanded;
    }
    else if (expanded && !disabled && isCitron) {
        // FIXME: change this into functions
        if (error) {
            trClasses = trExpandedErrorCitron;
        }
        else if (warning) {
            trClasses = trExpandedWarningCitron;
        }
        else {
            trClasses = trExpandedCitron;
        }
    }
    var expandableToggle = expanded && !disabled ? 'expanded' : 'not-expanded';
    var editingCss = iif(isCitron !== null && isCitron !== void 0 ? isCitron : false, editingCitron, editingLegacy);
    return (React.createElement(Component, __assign({ className: classes, css: editing && !disabled ? editingCss : undefined, id: id }, other, getAutomation(automationId), getDebug(sessionStorage.getItem('citrus-debug') === 'true', TYPE, VERSION)),
        React.createElement(Tr, { __altByIndex: __altByIndex, __checkHandler: __checkHandler, __checked: __checked, __expandableToggle: isNullOrEmpty(children) ? 'buffer' : expandableToggle, __onClick: onClick, alt: alt, css: trClasses, disabled: disabled, editing: false, error: error, warning: warning }, render === null || render === void 0 ? void 0 : render()),
        renderExpansion(id, columns, children, disabled, editing, error, warning, expanded, isCitron)));
};
var renderExpansion = function (id, columns, children, disabled, editing, error, warning, expanded, isCitron) {
    if (!expanded || (expanded && disabled))
        return;
    var rows = getChildrenByType(children, ['Tr']);
    var expansionStyles = trExpansion;
    if (isCitron) {
        // FIXME: change this into functions
        if (error)
            expansionStyles = trExpansionError;
        else if (warning)
            expansionStyles = trExpansionWarning;
        else
            trExpansionCitron;
    }
    if (isNotNullOrEmpty(rows)) {
        return rows.map(function (x, index) {
            return React.cloneElement(x, {
                __expandableToggle: 'buffer',
                css: expansionStyles,
                key: "table-td-toggle-".concat(id, "-").concat(index),
                disabled: disabled,
                editing: false,
                error: error,
                warning: warning,
            });
        });
    }
    return (React.createElement(Tr, { __expandableToggle: "", css: expansionStyles, disabled: disabled, editing: editing, error: error },
        React.createElement(Td, { colSpan: (columns !== null && columns !== void 0 ? columns : 0) + 1 }, children)));
};
RowExpandable.defaultProps = {
    __TYPE: 'RowExpandable',
};
export default RowExpandable;
